import { useContext } from 'react';

import { TemplateContext } from '../context/Template';

export function useTemplate() {
  const context = useContext(TemplateContext);

  return context;
}
